import { ProductType } from 'src/type/product';

import {
  Avatar,
  Button,
  TableRow,
  MenuItem,
  TableCell,
  Typography,
  IconButton,
  ListItemText,
} from '@mui/material';

import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

interface Props {
  row: ProductType;
  loading?: boolean;
  onEdit: VoidFunction;
  onDelete: VoidFunction;
  onMoveUp: VoidFunction;
  onMoveDown: VoidFunction;
  isFirst: boolean;
  isLast: boolean;
}

export default function ProductTableRow({
  row,
  loading,
  onEdit,
  onDelete,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
}: Props) {
  const { imageUrl, name, description, isEnable } = row;
  const popover = usePopover();
  const confirm = useBoolean();
  const router = useRouter();

  return (
    <>
      <TableRow>
        <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar alt="" sx={{ mr: 2 }} src={imageUrl}>
            {name?.[0].toUpperCase()}
          </Avatar>

          <ListItemText
            disableTypography
            primary={
              <Typography variant="body2" noWrap>
                {name}
              </Typography>
            }
            secondary={
              <Typography variant="caption" color="text.secondary" noWrap>
                {description}
              </Typography>
            }
          />
        </TableCell>

        <TableCell>
          <Label variant="soft" color={isEnable ? 'success' : 'error'}>
            {isEnable ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
          </Label>
        </TableCell>

        <TableCell align="center">
          {/* <Stack direction="row" spacing={1} justifyContent="flex-end"> */}
          <IconButton disabled={loading || isFirst} onClick={onMoveUp} size="small">
            <Iconify icon="eva:arrow-up-fill" />
          </IconButton>

          <IconButton disabled={loading || isLast} onClick={onMoveDown} size="small">
            <Iconify icon="eva:arrow-down-fill" />
          </IconButton>
          {/* </Stack> */}
        </TableCell>

        <TableCell align="right">
          <IconButton
            color={popover.open ? 'inherit' : 'default'}
            onClick={popover.onOpen}
            disabled={loading}
          >
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="top-right"
        sx={{ width: 170 }}
      >
        {/* <MenuItem
          onClick={() => {
            popover.onClose();
            router.push(paths.management.product.amount(row.id));
          }}
        >
          <Iconify icon="solar:settings-bold-duotone" />
          ตั้งค่าจำนวนทอง
        </MenuItem> */}

        <MenuItem
          onClick={() => {
            popover.onClose();
            router.push(paths.management.product.detail(row.id));
          }}
        >
          <Iconify icon="solar:money-bag-bold-duotone" />
          ตั้งค่าค่าบล็อค
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
            onEdit();
          }}
        >
          <Iconify icon="solar:pen-bold-duotone" />
          แก้ไข
        </MenuItem>

        {!['ทองรูปพรรณ 96.5%', 'ทองคำแท่ง 96.5%', 'ทองคำแท่ง 99.99%'].includes(row.name) && (
          <MenuItem
            onClick={() => {
              popover.onClose();
              confirm.onTrue();
            }}
            sx={{ color: 'error.main' }}
          >
            <Iconify icon="solar:trash-bin-trash-bold" />
            ลบ
          </MenuItem>
        )}
      </CustomPopover>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="ลบสินค้า"
        content={`คุณต้องการลบสินค้า ${row.name} ใช่หรือไม่?`}
        action={
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              onDelete();
              confirm.onFalse();
            }}
          >
            ยืนยันการลบ
          </Button>
        }
      />
    </>
  );
}
